module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d_container"
  }, [_c('my-menu', {
    attrs: {
      "menu-name": "home"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticClass: "phone",
    attrs: {
      "src": require("../assets/images/phone.png")
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_box box1"
  }, [_c('div', {
    staticClass: "down_left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/apple.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#333333",
      "display": "block"
    }
  }, [_vm._v("苹果版")])]), _vm._v(" "), _c('div', {
    staticClass: "down_right"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1171638702",
      "target": "_blank"
    }
  }, [_vm._v("人教版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1179268416",
      "target": "_blank"
    }
  }, [_vm._v("译林版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1179239368",
      "target": "_blank"
    }
  }, [_vm._v("北师大版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1179267262",
      "target": "_blank"
    }
  }, [_vm._v("外研版")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_box box2"
  }, [_c('div', {
    staticClass: "down_left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/android.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#333333",
      "display": "block"
    }
  }, [_vm._v("安卓版")])]), _vm._v(" "), _c('div', {
    staticClass: "down_right"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3585073",
      "target": "_blank"
    }
  }, [_vm._v("人教版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3589976",
      "target": "_blank"
    }
  }, [_vm._v("译林版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3589970",
      "target": "_blank"
    }
  }, [_vm._v("北师大版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3589974",
      "target": "_blank"
    }
  }, [_vm._v("外研版")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28cdc713","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Download.vue
// module id = 83
// module chunks = 0